import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Logo size="default" showSubtitle={true} variant="light" />
            </Link>
            <p className="text-white/70 leading-relaxed max-w-md">
              A creative sanctuary for serious writers who value craft over popularity. 
              Share your work, improve your skills, and connect with like-minded souls.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white/90">Explore</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/stories" className="text-white/60 hover:text-white transition-colors">
                  Browse Works
                </Link>
              </li>
              <li>
                <Link to="/challenges" className="text-white/60 hover:text-white transition-colors">
                  Challenges
                </Link>
              </li>
              <li>
                <Link to="/reading" className="text-white/60 hover:text-white transition-colors">
                  What Are You Reading?
                </Link>
              </li>
              <li>
                <Link to="/guest-authors" className="text-white/60 hover:text-white transition-colors">
                  Guest Authors
                </Link>
              </li>
              <li>
                <Link to="/spotlight" className="text-white/60 hover:text-white transition-colors">
                  Spotlight Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4 className="font-semibold mb-4 text-white/90">Community</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/groups" className="text-white/60 hover:text-white transition-colors">
                  Writing Groups
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/60 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/guidelines" className="text-white/60 hover:text-white transition-colors">
                  Community Guidelines
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/60 hover:text-white transition-colors">
                  How to Navigate
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Ownership & Originality Statement */}
        <div className="border-t border-white/10 mt-12 pt-8 mb-6" data-testid="footer-ownership-statement">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
            <p className="text-brand-gold font-medium text-sm tracking-wide">
              Writers own 100% of their work. Original writing only—no AI-generated content.
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Collectively Write. Made with <Heart className="w-4 h-4 inline text-brand-accent" /> for writers.
          </p>
          <p className="text-white/50 text-sm">
            Founded by Heather Wickham & Rachelle Allen
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
